import axios from "axios";
import { toast } from "react-toastify";

export const Fetch = async (
  url,
  setNewData,
  query,
  setLoading = null,
  setError
) => {
  if (url) {
    if (setLoading) setLoading(true);
    try {
      const res = await axios(query ? `${url}${query ?? ""}` : url, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/app.js",
        },
      });
      setNewData(res?.data?.data);
    } catch (err) {
      toast.error(err.response?.data?.message, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnFocusLoss: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
      if (setError) setError(err?.response);
      setNewData("");
    }
    if (setLoading) setLoading(false);
  }
};
